import { ICheckboxStyle } from '../models/index.js';
export const checkboxStyle: ICheckboxStyle = {
	children: {
		icon: {
			verticalAlign: 'middle',
		},
	},
};
